export const sameModule = (a, b) => (a && b && a.module === b.module);
export const samePath = (a, b) => (sameModule(a, b) && a.path === b.path);
export const sameActivity = (a, b) => (samePath(a, b) && a.activity === b.activity);
export const sameExercice = (a, b) => (sameExercice(a, b) && a.exercice === b.exercice);